"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Alphazer / alpha controller
const plugins_1 = require("./plugins");
class ImagesAlphaController extends plugins_1.FdmPlugin {
    constructor() {
        super(...arguments);
        // our controls
        this.controls = {
            alpha: { value: 0.5, type: 'slider', min: 0.1, max: 1, step: 0.01 }
        };
        // original alpha value
        this.originalAlpha = 1;
    }
    objectInjected() {
        this.name = 'Alphazed';
        this.originalAlpha = this.object.alpha;
    }
    refresh(newvalue = null, section = null) {
        // check in with mama
        super.refresh(newvalue, section);
        this.object.alpha = this.controls.alpha.value;
    }
    reset() {
        this.object.alpha = this.originalAlpha;
    }
}
// required name identifier
ImagesAlphaController.meta = {
    label: 'PLUGINS.IMAGES_ALPHA_CONTROLLER.LABEL',
    name: 'images-alpha-controller',
    translator: 'PLUGINS.IMAGES_ALPHA_CONTROLLER',
    tooltip: 'PLUGINS.IMAGES_ALPHA_CONTROLLER.TOOLTIP',
    icon: 'lightbulb-on',
    shortcut: false,
    category: plugins_1.FdmPlugin.category.debug,
    cardinality: plugins_1.FdmPlugin.cardinality.one,
    types: [plugins_1.FdmPlugin.types.transformController],
    ds_types: [plugins_1.FdmPlugin.ds_types.geotif]
};
exports.ImagesAlphaController = ImagesAlphaController;
